const defaultGeneralInformationSchema = {
  // Cidadão
  'citizen.name': {
    displayName: 'Nome',
    notAvailable: 'Nome não informado',
    mask: '',
    canCopy: false,
  },
  'citizen.socialName': {
    displayName: 'Nome social',
    notAvailable: 'Nome social não informado',
    mask: '',
    canCopy: false,
  },
  'citizen.cpf': {
    displayName: 'CPF',
    notAvailable: 'CPF não informado',
    mask: 'cpf',
    canCopy: true,
  },
  'citizen.cns': {
    displayName: 'CNS',
    notAvailable: 'CNS não informado',
    mask: 'cns',
    canCopy: true,
  },
  'citizen.birthDate': {
    displayName: 'Data de nascimento',
    notAvailable: 'Data de nascimento não informada',
    mask: 'date',
    canCopy: false,
  },
  'citizen.sex': {
    displayName: 'Sexo',
    notAvailable: 'Sexo não informado',
    mask: 'sex',
    canCopy: false,
  },
  'citizenHealth.email': {
    displayName: 'Email',
    notAvailable: 'Email não informado',
    mask: '',
    canCopy: false,
  },

  'citizen.phoneNumber': {
    displayName: 'Telefone',
    notAvailable: 'Telefone não informado',
    mask: 'phone',
    canCopy: false,
  },

  // Empresa
  tradeName: {
    displayName: 'Nome fantasia',
    notAvailable: 'Nome fantasia não informado',
    mask: '',
    canCopy: false,
  },
  cnpj: {
    displayName: 'CNPJ',
    notAvailable: 'CNPJ não informado',
    mask: 'cnpj',
    canCopy: true,
  },
  openingDate: {
    displayName: 'Data de abertura',
    notAvailable: 'Data de abertura não informada',
    mask: 'date',
    canCopy: false,
  },
  phoneNumber1: {
    displayName: 'Telefone 1',
    notAvailable: 'Telefone 1 não informado',
    mask: 'phone',
    canCopy: false,
  },
  phoneNumber2: {
    displayName: 'Telefone 2',
    notAvailable: 'Telefone 2 não informado',
    mask: 'phone',
    canCopy: false,
  },

  // Geral
  email: {
    displayName: 'Email',
    notAvailable: 'Email não informado',
    mask: '',
    canCopy: true,
  },
  phoneNumber: {
    displayName: 'Telefone',
    notAvailable: 'Telefone não informado',
    mask: 'phone',
    canCopy: true,
  },
  cns: {
    displayName: 'CNS',
    notAvailable: 'CNS não informado',
    mask: 'cns',
    canCopy: true,
  },
  cpf: {
    displayName: 'CPF',
    notAvailable: 'CPF não informado',
    mask: 'cpf',
    canCopy: true,
  },
  birthDate: {
    displayName: 'Data de nascimento',
    notAvailable: 'Data de nascimento não informada',
    mask: 'date',
    canCopy: false,
  },
  sex: {
    displayName: 'Sexo',
    notAvailable: 'Sexo não informado',
    mask: 'sex',
  }
}

export default defaultGeneralInformationSchema
